<div *ngFor="let item of items; let i = index">
  <div *ngIf="getControl(item) | async as control"
        [class.is-changed]="control.get('quantity')?.disabled"
        class="mb-cart-item-list"
        data-cy="mb-cart-item-list">
    <mb-cart-item [item]="item"
                  [quantityControl]="control.get('quantity')"
                  [readonly]="readonly"
                  [options]="options"
                  [isDisplayedInCartPage]="isDisplayedInCartPage"
                  [showYourPrice]="showYourPrice$ | async"
                  [showAddToCartButton]="showAddToCartButton"
                  [dataAnalyticsClickSource]="dataAnalyticsClickSource"
                  (removeEntry)="removeEntry($event)">
    </mb-cart-item>
  </div>
</div>
